import type { Activity } from '@xingroute/schema'

// Selection policy only; historical activities remain valid in the route contract.
export const SELECTABLE_ACTIVITIES = ['hiking', 'running'] as const satisfies readonly Activity[]

export function isSelectableActivity(activity: Activity): boolean {
  return SELECTABLE_ACTIVITIES.some((selectable) => selectable === activity)
}
